import {Box, HStack, Text} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {
  convertHtmlToFormat,
  countMobileDeMarkupOverhead,
  DEFAULT_PLATFORM_FORMAT,
  PLATFORM_FORMAT_MAP,
} from '@dms/shared';

// Matches the per-platform threshold in DescriptionFormField.tsx — keep in sync.
const MARKUP_OVERHEAD_RATIO = 0.1;

interface PlatformDescriptionCharacterCountProps {
  value: string | null;
  platformCode: AdvertisingPlatformCodeEnum;
}

export function PlatformDescriptionCharacterCount(props: PlatformDescriptionCharacterCountProps) {
  const config = PLATFORM_FORMAT_MAP[props.platformCode] ?? DEFAULT_PLATFORM_FORMAT;
  const {characterLimit} = config;

  if (!isNotNil(characterLimit)) {
    return null;
  }

  const converted = convertHtmlToFormat(props.value ?? '', config.format);
  const isMobileDe = config.format === 'mobileDe';
  const markupOverhead = isMobileDe ? countMobileDeMarkupOverhead(converted) : 0;
  const count = isMobileDe ? converted.length - markupOverhead : converted.length;
  const isOverLimit = count > characterLimit;
  const isMarkupOverLimit = isMobileDe && markupOverhead > characterLimit * MARKUP_OVERHEAD_RATIO;

  return (
    <HStack spacing={1} align="center">
      <Box
        width={2}
        height={2}
        borderRadius="medium"
        backgroundColor={isOverLimit || isMarkupOverLimit ? 'severity.warning' : 'severity.success'}
      />
      <Text size="xSmall" color="secondary">
        {isMarkupOverLimit
          ? `${count} / ${characterLimit} — ${i18n.t('page.advertisement.labels.markupOverheadExceeded')}`
          : `${count} / ${characterLimit}`}
      </Text>
    </HStack>
  );
}
